// core/i18n/languages.constant.ts
export interface Language {
    value: string;
    label: string;
    flagSvg: string;
}

export const LANGUAGES: Language[] = [
    {
        value: 'en',
        label: 'English',
        flagSvg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
                    <path d="M2.47827 4.69568C1.53309 5.92298 0.816336 7.33328 0.383301 8.86959H8.6522V4.69568H2.47827Z" fill="#0052B4"/>
                    <path d="M23.6168 8.86959C23.1837 7.33328 22.467 5.92298 21.5218 4.69568H15.3479V8.86959H23.6168Z" fill="#0052B4"/>
                    <path d="M0.383301 15.1305C0.816336 16.6668 1.53309 18.0771 2.47827 19.3044H8.6522V15.1305H0.383301Z" fill="#0052B4"/>
                    <path d="M15.3479 15.1305V19.3044H21.5218C22.467 18.0771 23.1837 16.6668 23.6168 15.1305H15.3479Z" fill="#0052B4"/>
                    <path d="M15.3479 0V4.69568L21.5218 4.69568C20.0522 2.76887 18.0522 1.24278 15.3479 0Z" fill="#0052B4"/>
                    <path d="M8.6522 24V19.3044H2.47827C3.94788 21.2311 5.94789 22.7572 8.6522 24Z" fill="#0052B4"/>
                    <path d="M8.6522 0C5.94789 1.24278 3.94788 2.76887 2.47827 4.69568H8.6522V0Z" fill="#0052B4"/>
                    <path d="M15.3479 24C18.0522 22.7572 20.0522 21.2311 21.5218 19.3044H15.3479V24Z" fill="#0052B4"/>
                    <path d="M9.79127 10.0435H0.0956957C0.0330437 10.3577 0 10.6748 0 11.0435C0 11.3665 0.0261319 11.6836 0.0956957 12H9.79127V10.0435Z" fill="#D80027"/>
                    <path d="M23.9043 10.0435H14.2087V12H23.9043C23.9739 11.6836 24 11.3665 24 11.0435C24 10.6748 23.9669 10.3577 23.9043 10.0435Z" fill="#D80027"/>
                    </svg>`
    },
    {
        value: 'km',
        label: 'Khmer',
        flagSvg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 11.9999C0 14.0788 0.528891 16.0342 1.45908 17.739L12 18.7825L22.5409 17.739C23.4711 16.0342 24 14.0788 24 11.9999C24 9.921 23.4711 7.96566 22.5409 6.26077L12 5.21729L1.45908 6.26077C0.528891 7.96566 0 9.921 0 11.9999H0Z" fill="#D80027"/>
                    <path d="M1.45898 6.26086H22.5408C20.5056 2.53073 16.5484 0 11.9999 0C7.45139 0 3.49425 2.53073 1.45898 6.26086V6.26086Z" fill="#0052B4"/>
                    <path d="M11.9999 24.0001C16.5484 24.0001 20.5056 21.4694 22.5408 17.7393H1.45898C3.49425 21.4694 7.45139 24.0001 11.9999 24.0001Z" fill="#0052B4"/>
                    <path d="M16.174 14.3478V12.7826H15.1305V10.6956L14.0871 9.65215L13.0436 10.6956V8.60867L12.0001 7.56519L10.9566 8.60867V10.6956L9.91312 9.65215L8.86964 10.6956V12.7826H7.8262V14.3478H6.78271V15.913H17.2175V14.3478H16.174Z" fill="#F0F0F0"/>
                    </svg>`
    }
];
